<template>
  <div class="app-step-one-prices">
    <h2 class="app-step-one-prices__title">
      WRITING CAN BE ADDED TO ANY DISTRIBUTION FOR AN ADDITIONAL FEE.
    </h2>

    <loading-bar v-if="isLoading"></loading-bar>

    <ul v-else class="app-step-one-prices__list">
      <li
        v-for="item in packages"
        :key="item.id"
        class="app-step-one-prices__item app-step-one-prices-item"
      >
        <div class="app-step-one-prices-item__header">
          <h4 class="app-step-one-prices-item__title">{{ item.name }}</h4>
          <p class="app-step-one-prices-item__price">
            <span>$</span> {{ item?.singleCreditPrice?.price }}
          </p>
        </div>
        <ul class="app-step-one-prices-item__body">
          <li v-for="(descriptionItem, index) in item.description" :key="index">
            {{ descriptionItem }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup>
import LoadingBar from '@modules/ui/loading-bar.vue'
import { usePackages } from '@core/composables/usePackages'

const { packages, isLoading } = usePackages()
</script>
